require('./authorizationDetail.scss');

import PropTypes from 'prop-types';

// @ vendors
import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import IbanValidator from 'iban';
// @ commons
import OKTableRowDetails from 'components/rebrand/OKTableRowDetails/OKTableRowDetails';
import OKTableRowDetailsItem from 'components/rebrand/OKTableRowDetails/OKTableRowDetailsItem/OKTableRowDetailsItem';
import { LABEL_DATE_TODAY, LABEL_DATE_YESTERDAY } from 'constants/commonsComponents';
import { OKButton } from 'commonsComponents/OKButton';
import { LabelDate } from 'commonsComponents/labelDate';
// @ components
import OKBarChart from 'components/charts/OKBarChart/OKBarChart';
import XTick from 'components/charts/pfmBarChart/xTick/xTick';
import { EmptyState } from 'commonsComponents/emptyState';
// @ actions
import  { changeTab } from 'actions/accountDebits';
import { receiptsFilterByName } from 'actions/accountDebits/receipts';
import { initSelectFilter } from 'actions/filters';
// @ utilities
import  { toFirstUppercase } from 'utilities/stringHelper';
import { truncateDecimal } from 'utilities/numberHelper';
import { getMonthNameFromDate, getDateRange, getDateMonthsBefore, todayDate } from 'utilities/dateHelper';
import { formatAmountObject } from 'utilities/currencyHelper';
const { i18n: { FormattedText, formatText, getLanguage } } = require('core/i18n');

class AuthorizationDetail extends React.Component {

    buildAverage = (builtData) => {
        return truncateDecimal(builtData.map(e => e.value).reduce((a, b) => a + b) / builtData.length);
    }

    buildData = (data) => {
        const today = todayDate();
        const firstDate = getDateMonthsBefore(today, 11);
        const dateRange = getDateRange(moment(firstDate).format('YYYY-MM'), today).map(date => moment(date).format('YYYY-MM'));
        return dateRange.map(key => {
            const date = moment(key, 'YYYY-MM');
            return {
                name: `${toFirstUppercase(getMonthNameFromDate(key, 'YYYY-MM'))} ${date.year()}`,
                value: data[key] || 0
            }
        })
    }

    handleShowReceipts = () => {
        const {
            changeTab,
            immTransaction,
            receiptsFilterByName,
            initSelectFilter
        } = this.props;
        const name = immTransaction.get('nombreActuante');
        const accountId = immTransaction.get('accountId');
        changeTab(0);
        receiptsFilterByName(accountId, name);
        initSelectFilter('receipts', 'name', true, name, 'todas', 'selectorFilter', name, name);
    }

    renderReceiptsChart = (receipts, builtData, referenceLineData, currencySymbol) => {
        if (receipts && receipts.size) {
            return (
                <div>
                    <h5 className="authorization-detail__chart-name">
                        <FormattedText value="authorization-annualExpense" />
                    </h5>
                    <OKBarChart
                        animationBegin={500}
                        axisLine={false}
                        bars={['value']}
                        data={builtData}
                        fills={['#FCB900']}
                        height={170}
                        interval={1}
                        margin={{right: 100, top: 10}}
                        referenceLineData={referenceLineData}
                        referenceLineStroke={'#505050'}
                        unit={currencySymbol}
                        width={'100%'}
                        xAxis="name"
                        xTickComponent={<XTick periodTime={'M'} />}
                        tooltipContent={(tooltip) => this.renderTooltipContent(tooltip, currencySymbol)}
                    />
                </div>
            )
        }
        return (
            <div className="authorization-detail__no-receipts">
                <EmptyState primaryText={formatText('authorization-noReceipts')} iconType="noitems-banking"/>
            </div>
        )
    }

    renderTooltipContent = (tooltip, currency) => {
        if (tooltip.active){
            const tooltipNumber =  Intl.NumberFormat('es-ES').format(tooltip.payload[0].payload.value);
            return(
                <span className="authorization-detail__tooltip">
                    <span>{`${tooltip.label}`}</span>
                    &nbsp;
                    &nbsp;
                    <span>{`${tooltipNumber} ${currency}`}</span>
                </span>
            )
        }
    }

    render() {
        const { immTransaction } = this.props;
        const receipts = immTransaction.getIn(['listaRecibos', 'recibos']);
        const beneficiaryName = receipts.getIn([0, 'titular']);
        const id = immTransaction.get('descClaveInterna');
        const iban = receipts.getIn([0, 'ctadeud']);
        const data = immTransaction.get('expenses').toJS();
        const language = getLanguage();
        const builtData = this.buildData(data);
        const average = this.buildAverage(builtData);
        const currency = receipts.getIn([0, 'codmon']);
        const plainAmountObject = {
            amount: average,
            currency
        }
        const currencySymbol = formatAmountObject(plainAmountObject, true).currencySymbol;
        const referenceLineData = {
            preLabel: `${formatText('authorization-average')}:`,
            label: `${Intl.NumberFormat('es-ES').format(average)} ${currencySymbol}`,
            value: average,
        }
        const date = (
            <LabelDate
                date={immTransaction.get('fechaFirma')}
                language={language}
                today={LABEL_DATE_TODAY}
                yesterday={LABEL_DATE_YESTERDAY}
            />
        )

        return (
            <tr>
                <td className="container-fluid" colSpan="5">
                    <div className="row authorization-detail__container">
                        <div className="col-sm-5">
                            <OKTableRowDetails title="accountDebitDetail-header">
                                {
                                    beneficiaryName &&
                                        <OKTableRowDetailsItem
                                            title="accountDebitDetail-beneficiaryName"
                                            value={beneficiaryName}
                                        />
                                }
                                <OKTableRowDetailsItem
                                    title="accountDebitDetail-startDate"
                                    value={date}
                                />
                                <OKTableRowDetailsItem
                                    title="accountDebitDetail-issuingCompanyId"
                                    value={id}
                                />
                                {
                                    iban &&
                                        <OKTableRowDetailsItem
                                            title="accountDebitDetail-ibanAccount"
                                            value={IbanValidator.printFormat(iban, ' ')}
                                        />
                                }
                                {
                                    receipts && receipts.size ?
                                        <OKButton
                                            modifier="link-complementary"
                                            onClick={this.handleShowReceipts}
                                        >
                                            <FormattedText value="authorizations-showReceipts" />
                                        </OKButton>
                                    : null
                                }
                            </OKTableRowDetails>
                        </div>
                        <div className="col-sm-7 authorization-detail__chart">
                            { this.renderReceiptsChart(receipts, builtData, referenceLineData, currencySymbol) }
                        </div>
                    </div>
                </td>
            </tr>
        )
    }
}

AuthorizationDetail.propTypes = {
    immTransaction: PropTypes.object,
    changeTab: PropTypes.func.isRequired,
    receiptsFilterByName: PropTypes.func.isRequired,
    initSelectFilter: PropTypes.func.isRequired
};

export default connect(
    null,
    {
        changeTab,
        receiptsFilterByName,
        initSelectFilter
    }
)(AuthorizationDetail);